module.exports = __webpack_public_path__ + "static/img/19.0b96706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/19.jpg
// module id = 91nV
// module chunks = 0